// reducer.js
export interface Menu {
  id: number;
  created_at: string;
  updated_at: string;
  created_by_id: string | null;
  updated_by_id: string | null;
  is_deleted: boolean;
  deleted_at: string | null;
  name: string;
  code: string;
  url: string;
}

export interface MenuState {
  data: Menu[];
  error: string | null;
}

export interface Action {
  type: string;
  payload: any;
}

const menuInitialState: MenuState = {
  data: [],
  error: null,
};

export const menuReducer = (
  state: MenuState = menuInitialState,
  action: Action
): MenuState => {
  switch (action.type) {
    case "FETCH_MENUS_SUCCESS":
      return { ...state, data: action.payload };
    case "FETCH_MENUS_ERROR":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
